/* this file is transformed by vux-loader */
/* eslint-disable */
import _objectSpread from "/Users/pajk01/workspace/n34220_autoconfig_STATIC/vue-scrm_temp/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { GetSpecialItemList } from '@/api/miniClinic';
import { mapGetters, mapMutations, mapState, mapActions } from 'vuex';
import { ACTION_MINI_SPECIALITEMLIST_GET, GETTER_MINI_SPECIALITEMLIST, MUTATION_MINI_SPECIALITEM_INFO } from '@/store/mutation_types';
import CopyRight from 'CopyRight';
import ListItem from '@/components/ListItem';
import NoData from '@/components/NoData';
export default {
  data: function data() {
    return {
      // specialItemList: [],
      pageNo: 1,
      pageSize: 50,
      empty: false
    };
  },
  created: function created() {
    this.getSpecialItemListAjax();
  },
  mounted: function mounted() {},
  components: {
    CopyRight: CopyRight,
    ListItem: ListItem,
    NoData: NoData
  },
  computed: _objectSpread({}, mapGetters({
    specialItemList: GETTER_MINI_SPECIALITEMLIST
  })),
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapMutations({
    setSpecialItemInfo: 'MUTATION_MINI_SPECIALITEM_INFO'
  })), mapActions([ACTION_MINI_SPECIALITEMLIST_GET])), {}, {
    //诊所详情
    tapEvent: function tapEvent(item) {
      this.setSpecialItemInfo(item);
      this.$router.push({
        name: 'MiniClinicSpecialItemDetail'
      });
    },

    /**
     *  获取特色项目列表
     *
     */
    getSpecialItemListAjax: function getSpecialItemListAjax() {
      var _this = this;

      var that = this;
      this.ACTION_MINI_SPECIALITEMLIST_GET(that.pageNo, that.pageSize).then(function (data) {
        if (data.length <= 0) {
          _this.empty = true;
        } else {
          return false;
        }
      });
    }
  })
};